import {
  TITLE_ID,
  NODE_ID,
  RADIO_ID,
  MARKS_ID,
  CHOICE_1,
  CHOICE_2,
  CHOICE_3,
  CHOICE_4,
  PARENT_ID,
  BLANKS_ID,
  CHOICES_ID,
  QUESTION_ID,
  SETTINGS_ID,
  INLINE_TEXT_ID,
  ANSWER_TEXT_ID,
  ANSWERS_TEXT_ID,
  BLANK_ANSWER_ID,
  LEARNING_GOAL_ID,
  AI_GEN_IDENTIFIER,
  GENERATE_USING_AI,
  QUESTION_END_TAG,
  QUESTION_START_TAG,
  WS_AI_QUESTION_TAGS,
  QUESTION_TYPE_INLINE_TEXT,
  BLANKS_ANSWER_REPLACEMENT,
  QUESTION_TYPE_TEXT_RESPONSE,
  QUESTION_TYPE_TRUE_OR_FALSE,
  QUESTION_TYPE_MULTIPLE_CHOICE,
  QUESTION_TYPE_FILL_IN_THE_BLANKS,
} from "Worksheet/modules/WorksheetConstants";

export {
  AI_GEN_IDENTIFIER,
  GENERATE_USING_AI,
  QUESTION_END_TAG,
  QUESTION_START_TAG,
  WS_AI_QUESTION_TAGS,
  BLANKS_ANSWER_REPLACEMENT,
  QUESTION_TYPE_INLINE_TEXT,
  QUESTION_TYPE_TEXT_RESPONSE,
  QUESTION_TYPE_TRUE_OR_FALSE,
  QUESTION_TYPE_MULTIPLE_CHOICE,
  QUESTION_TYPE_FILL_IN_THE_BLANKS,
};

export const TYPE_OF_QUESTION_TAG = WS_AI_QUESTION_TAGS.TYPE_OF_QUESTION_TAG;

export const AI_SUPPORTED_QUESTIONS = [
  QUESTION_TYPE_INLINE_TEXT,
  QUESTION_TYPE_TEXT_RESPONSE,
  QUESTION_TYPE_TRUE_OR_FALSE,
  QUESTION_TYPE_MULTIPLE_CHOICE,
  QUESTION_TYPE_FILL_IN_THE_BLANKS,
];

export const AI_WORKSHEET_TAGS = {
  PLAN_END_TAG: "</wp>",
  PLAN_START_TAG: "<wp>",
  QUESTION_END_TAG: "</wq>",
  QUESTION_START_TAG: "<wq>",
  INSTRUCTION_END_TAG: "</wi>",
  INSTRUCTION_START_TAG: "<wi>",
  VISUALIZATION_END_TAG: "</vs>",
  VISUALIZATION_START_TAG: "<vs>",
};

const COMMON_FIELD_NAMES = [
  TITLE_ID,
  RADIO_ID,
  MARKS_ID,
  CHOICE_1,
  CHOICE_2,
  CHOICE_3,
  CHOICE_4,
  BLANKS_ID,
  CHOICES_ID,
  QUESTION_ID,
  SETTINGS_ID,
  INLINE_TEXT_ID,
  ANSWER_TEXT_ID,
  ANSWERS_TEXT_ID,
  BLANK_ANSWER_ID,
  LEARNING_GOAL_ID,
];

export const FIELD_SET_NAMES_V1 = [NODE_ID, ...COMMON_FIELD_NAMES];
export const FIELD_SET_NAMES_V2 = [PARENT_ID, ...COMMON_FIELD_NAMES];

export const INSTRUCTION_REGEX = {
  RGX1: /<(ul|ol)[^>]*>[\s\S]*?<\/\1>/gi, // Regex to extract list content
  RGX2: /<\/li>(?:\s|<br\s*\/?>|[\r\n])+<li/gi, // Regex to remove br tags between list items
  RGX3: /(<(ul|ol)[^>]*>)(?:\s|<br\s*\/?>|[\r\n])+/gi, // Regex to remove br tags after list open tag
  RGX4: /(?:\s|<br\s*\/?>|[\r\n]+)+(<\/(ul|ol)>)/gi, // Regex to remove br tags before list close tag
};
